import { render } from "./ReporteProductos.vue?vue&type=template&id=49f47136&scoped=true"
import script from "./ReporteProductos.vue?vue&type=script&lang=js"
export * from "./ReporteProductos.vue?vue&type=script&lang=js"

import "./ReporteProductos.vue?vue&type=style&index=0&id=49f47136&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f47136"]])

export default __exports__